export default __webpack_public_path__ + "static/media/submenu-robot-c6.71bca75f.png";